import styled from 'styled-components';
import { Row, Col, Input, Table, Modal } from 'antd';


export const TopSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    margin: 0px 64px;
    margin-top: 40px;
    margin-bottom: 0px;
`
export const TopTextWrapper = styled.div`
h1 {
    letter-spacing: -0.025em;
    font-weight: 700;
    font-size: 1.875rem;
    line-height: 2.25rem;
    color: var(--primary-text-color);
}
p {
    /* color: rgb(107 114 128 / var(--tw-text-opacity, 1)); */
    color: var(--secondary-text-color);
    margin-top: 0.5rem;
}
`


export const Wrapper = styled(Row)`
  background: var(--primary-bg);
  margin: 0px 64px;
  padding: 32px 0px;

  .ant-input::placeholder {
    color: var(--secondary-text-color) !important;
    opacity: 1;
  }

  .upload-button {
    boder: none;
    border-style: none;
    color: #ffffff !important;
    background: #8a3ef4 !important;
    font-size: 14px;

    &:hover {
      color: #ffffff !important;
      background: #8a3ef4 !important;
    }
  }
 
  .ant-table-thead > tr > th {
    background: var(--primary-bg) !important;
    color: #64748b !important;
    padding: 1px 16px !important;
    height: 48px !important;
    font-size: 14px !important;
    border-top:1px solid var(--border-color) !important; 
  }

  .ant-table-thead > tr > th:first-child{
    border-left:1px solid var(--border-color) !important;
    border-top-left-radius: 10px !important;
  }
  .ant-table-thead > tr > th:last-child {
      border-right:1px solid var(--border-color) !important;
      border-top-right-radius: 10px !important;
  }  

  .ant-table-tbody > tr > td {
    padding: 16px !important;
    border-bottom: 1px solid var(--border-color);
    white-space: nowrap;
  }
  
  // .ant-table-tbody > tr:first-child > td {
  //   padding: 0px !important;
  // }
  .ant-table-tbody > tr > td:first-child{
    border-left:1px solid var(--border-color);
  }
  .ant-table-tbody > tr > td:last-child {
      border-right:1px solid var(--border-color);
  }
  .ant-table-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 10px !important;
  }    
  .ant-table-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 10px !important;
  }    
  .ant-table-tbody .ant-typography >strong {
    font-size: 14px !important;
    font-weight: 500 !important;
    color:var(--primary-text-color) !important;
  }     

  .ant-table-cell {
    font-family: 'Poppins', sans-serif !important;
  }

  .ant-table-container {
    overflow: auto;
    height: 440px;
  }

  .ant-pagination-item-link {
    boder: none;
    border-style: none;
    color: #ffffff !important;
    background: #8a3ef4 !important;
  }

  .ant-pagination-item.ant-pagination-item-1.ant-pagination-item-active {
    boder: none;
    border-style: none;
  }

  .ant-pagination-item-active {
    boder: none;
    border-style: none;
    color: #8a3ef4 !important;
    border: 1px solid #8a3ef4 !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid #8a3ef4 !important;
  }

  .ant-select-arrow {
    color: #8a3ef4 !important;
  }

  .ant-select-selection-item {
    color: #8a3ef4 !important;
  }

  .ant-pagination-total-text {
    color: #8a3ef4 !important;
    text-align: start;
  }
`;

export const StyledHeader = styled(Col)`
  .ant-input-affix-wrapper {
    border-radius: 10px;
    background: var(--primary-bg);
    border-color: var(--border-color);
  }
  .ant-input-affix-wrapper-focused {
    border-color: #8a3ef4 !important;
  }
    .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
      border-color: #8a3ef4 !important;
    }

`;

export const SearchBar = styled(Input)`
  width: 400px;
  border-radius: 20px;
  background: var(--secondary-bg);
  border: 1px solid var(--border-color);

  &:hover,
  &:focus {
    border-color: var(--primary-color);
  }
`;

export const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  width: 100%;
  padding: 0 10px;
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: var(--secondary-text-color);
  padding: 8px 0;
  font-size: 1rem;
`;

export const StyledTable = styled(Table)`
  .ant-table {
    background: var(--primary-bg);
    width: 100%;
  }

  .ant-table-container {
    width: 100%;
  }

  .ant-table-content {
    width: 100%;
  }

  .ant-table-thead > tr > th {
    background: var(--secondary-bg);
    color: var(--text-primary);
    border-bottom: 1px solid var(--border-color);
    white-space: nowrap;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid var(--border-color);
    white-space: nowrap;
  }

  .ant-table-tbody > tr:hover > td {
    background: rgba(138, 62, 244, 0.05);
  }

  .ant-table-pagination {
    background: var(--primary-bg);
    margin: 35px 0px 0px 0px;
  }

  .ant-pagination-item {
    background: var(--secondary-bg);
    border-color: var(--border-color);
    display: none;

    a {
      color: var(--text-primary);
    }
  }

  .ant-pagination-item-active {
    border-color: var(--primary-color);

    a {
      color: var(--primary-color);
    }
  }

  .ant-pagination-prev button,
  .ant-pagination-next button {
    background: var(--secondary-bg);
    border-color: var(--border-color);
    color: var(--text-primary);
  }
  .ant-pagination-total-text {
    flex: 1;
    color: #64748b !important;
  }
 .ant-pagination-prev button,.ant-pagination-next button {
  color: #64748b !important;
  font-size: 14px !important;
  font-weight: 500 !important;
 }

  .ant-table-cell {
    color: var(--primary-text-color);
  }
  .ant-table-tbody > tr.ant-table-row-selected > td{
    background-color: var(--border-color) !important;
  }

   .ant-table-thead > tr > th {
    background: var(--primary-bg) !important;
    color: #64748b !important;
    padding: 1px 16px !important;
    height: 48px !important;
    font-size: 14px !important;
    border-top:1px solid var(--border-color) !important; 
  }

  .ant-table-thead > tr > th:first-child{
    border-left:1px solid var(--border-color) !important;
    border-top-left-radius: 10px !important;
  }
  .ant-table-thead > tr > th:last-child {
      border-right:1px solid var(--border-color) !important;
      border-top-right-radius: 10px !important;
  }  

  .ant-table-tbody > tr > td {
    padding: 16px !important;
    border-bottom: 1px solid var(--border-color);
    white-space: nowrap;
   background: var(--primary-bg);
  }
  
  .ant-table-tbody > tr:first-child > td:empty {
    padding: 0px !important;
  }
.ant-table-tbody > tr.ant-table-measure-row:first-child td {
  padding: 0 !important;
}
  .ant-table-tbody > tr > td:first-child{
    border-left:1px solid var(--border-color);
  }
  .ant-table-tbody > tr > td:last-child {
      border-right:1px solid var(--border-color);
  }
  .ant-table-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 10px !important;
  }    
  .ant-table-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 10px !important;
  }    
  .ant-table-tbody .ant-typography >strong {
    font-size: 14px !important;
    font-weight: 500 !important;
    color:var(--primary-text-color) !important;
  }     

  .ant-table-cell {
    font-family: 'Poppins', sans-serif !important;
  }

  .ant-table-container {
    height: 440px;
  }

  .ant-pagination-item-link {
    boder: none;
    border-style: none;
    color: #ffffff !important;
    background: #8a3ef4 !important;
  }

  .ant-pagination-item.ant-pagination-item-1.ant-pagination-item-active {
    boder: none;
    border-style: none;
  }

  .ant-pagination-item-active {
    boder: none;
    border-style: none;
    color: #8a3ef4 !important;
    border: 1px solid #8a3ef4 !important;
  }
  .ant-select-single:not(.ant-select-customize-input)
  .ant-select-selector {
    height: 38px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-select:not(.ant-select-customize-input) 
  .ant-select-selector {
    border: 1px solid var(--border-color)!important;
  }
  .ant-select-selection-item {
    color: rgb(100, 116, 139)!important;
  }
  .ant-select:not(.ant-select-customize-input) 
  .ant-select-selector {
    background-color: var(--primary-bg) !important;
  }
  .ant-select-arrow{
    color: rgb(100, 116, 139)!important;
  }
  .ant-pagination-options {
    margin-left: 9px;
  }
  .ant-table-selection {
    margin-left: -1px;
  }
  .ant-checkbox{
    margin-left: -1px;
  }

`;

export const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    border: 1px solid var(--border-color) !important;
    border-radius: 12px;
    background-color: var(--primary-bg) !important;
    display: flex;
    flex-direction: column;
    max-height: 80vh; /* Limit modal height to 90% of viewport height */
  }

  .ant-modal-header {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom: none !important;
    background-color: var(--border-color) !important;
    padding: 16px 24px;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .ant-modal-title {
    color: var(--primary-text-color);
  }

  .anticon {
    color: var(--primary-text-color);
  }  

  .ant-modal-body {
    background: var(--primary-bg);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 24px;
    overflow-y: auto;
    flex: 1;
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #d9d9d9;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #bfbfbf;
    }
    .ant-select {
    color: var(--primary-text-color);
    font-size: 16px;
  }
  }

  .ant-modal-footer {
    border-top: 1px solid var(--border-color);
    padding: 16px 24px;
    position: sticky;
    bottom: 0;
    background: var(--primary-bg);
    z-index: 1;
  }

  .modal-button {
    border: none;
    border-style: none;
    color: #ffffff !important;
    background: #8a3ef4 !important;
  }

  .ant-input {
    border: 1px solid var(--border-color) !important;
  }

  .ant-form-item label {
    color: var(--primary-text-color) !important;
    font-weight: 600;
  }

  .ant-upload.ant-upload-drag {
    border: 1px solid var(--border-color) !important;
    background: var(--primary-bg) !important;
  }

  .ant-upload.ant-upload-drag p.ant-upload-text {
    color: var(--primary-text-color) !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid var(--border-color) !important;
    background: var(--primary-bg) !important;
  }    

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 40px !important;
    padding: 2px 11px !important;
  }
`;

export const SegmentWrapper = styled.div`
  .ant-segmented {
    background-color: var(--border-color) !important;
  }
  .ant-segmented-item{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--secondary-text-color) !important;

    &:hover {
      color: none !important;
    }
  }  
  .ant-segmented-item-selected{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-segmented-item-label{
    font-size: 16px;
    font-weight: 600;
  }
  .ant-segmented-item-selected {
    background-color: var(--primary-bg) !important;
    color: var(--primary-text-color) !important;
  }
`;
